import { useEffect, useState } from 'react';
import {
  Box,
  Divider,
  Flex,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
	Thead,
  Tbody,
	Tfoot,
  Td,
  Text,
  Th,
  Tr,
	Checkbox,
	Image
} from '@chakra-ui/react';
import { FiMoreVertical } from 'react-icons/fi';
import { MdArrowDropDown, MdArrowDropUp } from 'react-icons/md'

import { useAuth } from '../../../hooks/auth';
import { formatPrice } from '../../../utils/format';
import { FinJsonDTO } from '../../../dtos/FinJsonDTO';
import { TituloDTO } from '../../../dtos/TituloDTO';

type SortData = {
  por: string;
  cres: boolean;
}

type ControlsData = {
	page: number;
	perPage: number;
	totalPage: number;
}

interface DTTableParams {
  titulos: TituloDTO[];
  pesqTitulos: TituloDTO[];
  sort: SortData;
  setSort: (sort: SortData) => void;
  controls: ControlsData;
  handleUpdateList: (page: number, perPage: number, finans: TituloDTO[]) => void;
	setTituloModal: (product: FinJsonDTO) => void;
	setModalTituloVisible: (open: boolean) => void;
	setModalTituloEditVisible: (open: boolean) => void;
	setModalTituloDeleteVisible: (open: boolean) => void;
	titulosBaixa: FinJsonDTO[];
	setTitulosBaixa: (titulos: FinJsonDTO[]) => void;
	parcsBaixa: string[];
	setParcsBaixa: (id_baixa: string[]) => void;
	pagesBaixa: number[];
	setPagesBaixa: (page: number[]) => void;
};

const DTTable: React.FC<DTTableParams> = ({
	titulos,
	pesqTitulos,
  sort,
  setSort,
  controls,
  handleUpdateList,
	setTituloModal,
	setModalTituloVisible,
	setModalTituloEditVisible,
	setModalTituloDeleteVisible,
	titulosBaixa,
	setTitulosBaixa,
	parcsBaixa,
	setParcsBaixa,
	pagesBaixa,
	setPagesBaixa,
}) => {
	const { permissions } = useAuth();

	const [amortTotal, setAmortTotal] = useState('');
	const [descontoTotal, setDescontoTotal] = useState('');
	const [jurosTotal, setJurosTotal] = useState('');
	const [multaTotal, setMultaTotal] = useState('');
	const [pagoTotal, setPagoTotal] = useState('');
	const [sCredTotal, setSCredTotal] = useState('');
	const [sDebTotal, setSDebTotal] = useState('');
	const [vCredTotal, setVCredTotal] = useState('');
	const [vDebTotal, setVDebTotal] = useState('');
	
  function handleSort(prop: string) {
		let mapped: TituloDTO[] = [];

    const auxCres = !sort.cres;

    if (sort.por === prop) {
      if (auxCres) {
        mapped = pesqTitulos.sort((a, b) => {
          return (
            +(Object(a)[prop] > Object(b)[prop]) ||
            +(Object(a)[prop] === Object(b)[prop]) - 1
          );
        });
      } else {
        mapped = pesqTitulos.sort((a, b) => {
          return (
            +(Object(a)[prop] < Object(b)[prop]) ||
            +(Object(a)[prop] === Object(b)[prop]) - 1
          );
        });
      }
      setSort({ ...sort, cres: auxCres });
    } else {
      mapped = pesqTitulos.sort((a, b) => {
        return (
          +(Object(a)[prop] > Object(b)[prop]) ||
          +(Object(a)[prop] === Object(b)[prop]) - 1
        );
      });
      setSort({ por: prop, cres: true });
    }

    // setSort({ por: prop, cres: !sort.cres });

    handleUpdateList(1, controls.perPage, mapped);
  };

	useEffect(() => {
		let auxAmort = 0, auxDesc = 0, auxJuros = 0, auxMulta = 0, auxPago = 0;
		let auxSaldoCred = 0, auxSaldoDeb = 0, auxValorCred = 0, auxValorDeb = 0;

		for (let i = 0; i < titulos.length; i++) {
			auxAmort += titulos[i].amortizado;
			auxDesc += titulos[i].desconto;
			auxJuros += titulos[i].juros;
			auxMulta += titulos[i].multa;
			auxPago += titulos[i].pago;
			auxSaldoCred += titulos[i].saldo_cred;
			auxSaldoDeb += titulos[i].saldo_deb;
			auxValorCred += titulos[i].vlr_cred;
			auxValorDeb += titulos[i].vlr_deb;
		};

		setAmortTotal(formatPrice(auxAmort));
		setDescontoTotal(formatPrice(auxDesc));
		setJurosTotal(formatPrice(auxJuros));
		setMultaTotal(formatPrice(auxMulta));
		setPagoTotal(formatPrice(auxPago));
		setSCredTotal(formatPrice(auxSaldoCred));
		setSDebTotal(formatPrice(auxSaldoDeb));
		setVCredTotal(formatPrice(auxValorCred));
		setVDebTotal(formatPrice(auxValorDeb));
	}, [titulos]);

	function handleCkeckbox(value: boolean, titulo: TituloDTO, id_parcela: string) {
		const indexParcela = titulo.fin_json.parcelas.findIndex(parc => parc.id === id_parcela);
		const parcela = titulo.fin_json.parcelas[indexParcela];

		if (value) {
			const indexTitulo = titulosBaixa.findIndex(item => item.id === titulo.id);

			if (indexTitulo !== -1) {
				const auxTitulosBaixa = titulosBaixa;
				// auxTitulosBaixa[indexTitulo].fin_json.parcelas.push(parcela);
				auxTitulosBaixa[indexTitulo].parcelas.push(parcela);
				
				setParcsBaixa([...parcsBaixa, id_parcela]);
				setTitulosBaixa([...auxTitulosBaixa]);
				return;
			};

			const auxTitulosBaixa = titulosBaixa;
			const auxTitulo = titulo;
			auxTitulo.fin_json.parcelas = [parcela];
			// auxTitulosBaixa.push(auxTitulo);
			auxTitulosBaixa.push(auxTitulo.fin_json);

			setParcsBaixa([...parcsBaixa, id_parcela]);
			setTitulosBaixa([...auxTitulosBaixa]);
		} else {
			
			const auxTitulosBaixa = titulosBaixa;

			const auxParcsBaixa = parcsBaixa.filter((item: string) => item !== id_parcela);
			setParcsBaixa([...auxParcsBaixa]);
			// setParcsBaixa((current: string[]) => current.filter((item: string) => item !== id_parcela));
			
			const indexTitulo = auxTitulosBaixa.findIndex(item => item.id === titulo.id);

			// if (auxTitulosBaixa[indexTitulo].fin_json.parcelas.length > 1) {
			if (auxTitulosBaixa[indexTitulo].parcelas.length > 1) {
				// const indexParcel = auxTitulosBaixa[indexTitulo].fin_json.parcelas.findIndex(item => item.id === id_parcela);
				// const auxParcelas = auxTitulosBaixa[indexTitulo].fin_json.parcelas;
				const indexParcel = auxTitulosBaixa[indexTitulo].parcelas.findIndex(item => item.id === id_parcela);
				const auxParcelas = auxTitulosBaixa[indexTitulo].parcelas;
				auxParcelas.splice(indexParcel, 1);

				// auxTitulosBaixa[indexTitulo].fin_json.parcelas = auxParcelas;
				auxTitulosBaixa[indexTitulo].parcelas = auxParcelas;

				setTitulosBaixa([...auxTitulosBaixa]);
				return;
			};

			auxTitulosBaixa.splice(indexTitulo, 1);
			setTitulosBaixa([...auxTitulosBaixa]);
		};
	};

	async function handleCheckAll(value: boolean) {
		if (value) {
			const filtered_array = titulosBaixa;

			// Filtra somente as que não existem no array de baixa
			for (let i = 0; i < titulos.length; i++) {
				const indexTitulo = filtered_array.findIndex(titulo => titulo.id === titulos[i].id);
				if (indexTitulo === -1) {
					// filtered_array.push(titulos[i]);
					filtered_array.push(titulos[i].fin_json);
				} else {
					// filtered_array[indexTitulo].fin_json.parcelas = titulos[i].fin_json.parcelas;
					filtered_array[indexTitulo].parcelas = titulos[i].fin_json.parcelas;
				};
			};

			setTitulosBaixa([...filtered_array]);
			// setPagesBaixa((oldArray: number[]) => [...oldArray, controls.page]);
			setPagesBaixa([...pagesBaixa, controls.page]);

			// Filtra somente as parcelas que não existe no array de baixa
			for (let i = 0; i < filtered_array.length; i++) {
				// for (let j = 0; j < filtered_array[i].fin_json.parcelas.length; j++) {
				for (let j = 0; j < filtered_array[i].parcelas.length; j++) {
					// const indexParcBaixa = parcsBaixa.findIndex(item => item === filtered_array[i].fin_json.parcelas[j].id);
					const indexParcBaixa = parcsBaixa.findIndex(item => item === filtered_array[i].parcelas[j].id);
					if (indexParcBaixa === -1) {
						const auxParcsBaixa = parcsBaixa;
						// auxParcsBaixa.push(filtered_array[i].fin_json.parcelas[j].id);
						auxParcsBaixa.push(filtered_array[i].parcelas[j].id);

						// setParcsBaixa((oldArray: any[]) => [...oldArray, filtered_array[i].fin_json.parcelas[j].id]);
						setParcsBaixa([...auxParcsBaixa]);
					};
				};
			};
		} else {
			const auxTitulosBaixa = titulosBaixa;
			const auxParcsBaixa = parcsBaixa;

			for (let i = 0; i < titulos.length; i++) {
				for (let j = 0; j < titulos[i].fin_json.parcelas.length; j++) {
					// se Existir a parcela, exclui
					const indexParcBaixa = auxParcsBaixa.findIndex(item => item === titulos[i].fin_json.parcelas[j].id);
					if (indexParcBaixa >= 0) {
						auxParcsBaixa.splice(indexParcBaixa, 1);
					};
				};
				// se exixtir o titulo, exclui
				const indexTitulo = titulosBaixa.findIndex(item => item.id === titulos[i].id);
				if (indexTitulo >= 0) {
					auxTitulosBaixa.splice(indexTitulo, 1);
				};
			};

			setTitulosBaixa([...auxTitulosBaixa]);
			setParcsBaixa([...auxParcsBaixa]);

			const indexPageBaixa = pagesBaixa.findIndex(page => page === controls.page);
			const auxPagesBaixa = pagesBaixa;
			auxPagesBaixa.splice(indexPageBaixa, 1);
			setPagesBaixa([...auxPagesBaixa]);
		};
	};

  return (
    <Table w="100%" colorScheme="blackAlpha" size="sm">
      <Thead>
        <Tr>
					<Th cursor="pointer" mx={0} px={0}>
						<Checkbox
							mx={0}
							isChecked={pagesBaixa.includes(controls.page)}
							onChange={(e: any) => handleCheckAll(e.target.checked)}
						/>
					</Th>

					<Th py={2} px={1} cursor="pointer" onClick={() => handleSort('id_parcela')}>
            <Flex align="center">
              Nome
              {sort.por === 'id_parcela' && sort.cres ? (
                <Icon as={MdArrowDropUp} fontSize="20" />
              ) : (
                sort.por === 'id_parcela' &&
                !sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
              )}
            </Flex>
          </Th>

					<Th py={2} pr={1} cursor="pointer" onClick={() => handleSort('parcela')} >
						<Flex justifyContent="flex-end">
							Parcela
							{sort.por === 'parcela' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'parcela' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('name_pay')}>
						<Flex w="100%" justifyContent="flex-end">
              Pagamento
              {sort.por === 'name_pay' && sort.cres ? (
                <Icon as={MdArrowDropUp} fontSize="20" />
              ) : (
                sort.por === 'name_pay' &&
                !sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
              )}
            </Flex>
          </Th>

					<Th px={1} cursor="pointer" onClick={() => handleSort('vlr_cred')}>
						<Flex justifyContent="flex-end">
							Vlr Cred.
							{sort.por === 'vlr_cred' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'vlr_cred' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th px={1} cursor="pointer" onClick={() => handleSort('vlr_deb')}>
						<Flex justifyContent="flex-end">
							Vlr Deb.
							{sort.por === 'vlr_deb' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'vlr_deb' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th pr={1} pl={3} cursor="pointer" onClick={() => handleSort('amortizado')}>
						<Flex justifyContent="flex-end">
							Amortizado
							{sort.por === 'amortizado' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'amortizado' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th pr={1} pl={3} cursor="pointer" onClick={() => handleSort('desconto')}>
						<Flex justifyContent="flex-end">
							Desconto
							{sort.por === 'desconto' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'desconto' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th px={1} cursor="pointer" onClick={() => handleSort('juros')}>
						<Flex justifyContent="flex-end">
							Juros
							{sort.por === 'juros' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'juros' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th px={1} cursor="pointer" onClick={() => handleSort('multa')}>
						<Flex justifyContent="flex-end">
							Multa
							{sort.por === 'multa' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'multa' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th px={1} cursor="pointer" onClick={() => handleSort('pago')}>
						<Flex justifyContent="flex-end">
							Pago
							{sort.por === 'pago' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'pago' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th px={1} cursor="pointer" onClick={() => handleSort('saldo_cred')}>
						<Flex w="100px" justifyContent="flex-end">
							Saldo Cred.
							{sort.por === 'saldo_cred' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'saldo_cred' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th px={1} cursor="pointer" onClick={() => handleSort('saldo_deb')}>
						<Flex justifyContent="flex-end">
							Saldo Deb.
							{sort.por === 'saldo_deb' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'saldo_deb' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th pl={1} pr={1} cursor="pointer" onClick={() => handleSort('data_baixa')}>
						<Flex w="100px" justifyContent="flex-end">
							Data Baixa
							{sort.por === 'data_baixa' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'data_baixa' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th px={1} cursor="pointer" onClick={() => handleSort('data')}>
						<Flex justifyContent="flex-end">
							Data
							{sort.por === 'data' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'data' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th pl={3} pr={1} cursor="pointer" onClick={() => handleSort('vencimento')}>
						<Flex justifyContent="flex-end">
							Vencimento
							{sort.por === 'vencimento' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
									sort.por === 'vencimento' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					{(permissions.incluir || permissions.alterar) && (
						<Th></Th>
					)}
        </Tr>
      </Thead>

      <Tbody>
        {titulos.map(titulo => {
          return (
						<Tr key={titulo.id_parcela} fontSize={14} fontWeight={500} cursor="pointer">
							{/* BAIXADO */}
							<Td px={0}>
								{!titulo.baixado && (
									<Checkbox
										isChecked={parcsBaixa.includes(titulo.id_parcela)}
										onChange={(e: any) => handleCkeckbox(e.target.checked, titulo, titulo.id_parcela)}
									/>
								)}
							</Td>

							{/* NOME */}
              <Td py={1} px={1}>
								<Flex w="100%" justify="flex-start">
									<Text w="218px" color="blue.500" noOfLines={1}>
										{titulo.nome}
									</Text>
								</Flex>
              </Td>

							{/* PARCELA */}
							<Td isNumeric py={1} px={1} color="gray.500">
								<Text>{titulo.parcela}</Text>
              </Td>

							{/* NAME PAY */}
							<Td isNumeric py={1} px={1} color="gray.500">
								<Flex align="center" justify="flex-end">
									<Text fontSize={13}>{titulo.name_pay}</Text>
									{titulo.url_pay && (
										<Image src={titulo.url_pay} objectFit='cover' w='25px' h="20px" ml={2} />
									)}
								</Flex>
							</Td>

							{/* VLR CRED */}
							<Td isNumeric py={1} px={1} color="gray.500">
								{titulo.vlr_cred_formatted}
							</Td>

							{/* VLR DEB */}
							<Td isNumeric py={1} px={1} color="gray.500">
								{titulo.vlr_deb_formatted}
							</Td>

							{/* AMORTIZADO */}
							<Td isNumeric py={1} px={1} color="gray.500">
								{titulo.amortizado_formatted}
							</Td>

							{/* DESCONTO */}
							<Td isNumeric py={1} px={1} color="gray.500">
								{titulo.desconto_formatted}
							</Td>

							{/* JUROS */}
							<Td isNumeric py={1} px={1} color="gray.500">
								{titulo.juros_formatted}
							</Td>

							<Td isNumeric py={1} px={1} color="gray.500">
								{titulo.multa_formatted}
							</Td>

							{/* PAGO */}
							<Td isNumeric py={1} px={1} color="gray.500">
								{titulo.pago_formatted}
							</Td>

							{/* SALDO CRED */}
							<Td isNumeric py={1} px={1} color="gray.500">
								{titulo.saldo_cred_formatted}
							</Td>

							{/* SALDO DEB */}
							<Td isNumeric py={1} px={1} color="gray.500">
								{titulo.saldo_deb_formatted}
							</Td>

							{/* DATA BAIXA */}
							<Td isNumeric py={1} px={1} color="gray.500">
								{titulo.data_baixa}
							</Td>

							{/* DATA */}
							<Td isNumeric py={1} pl={2} pr={1} color="gray.500">
								{titulo.data}
							</Td>

							{/* VENCIMENTO */}
							<Td isNumeric py={1} px={1} color="gray.500">
								{titulo.vencimento}
							</Td>

							{/* MENU */}
							{(permissions.alterar || permissions.alterar) && (
								<Td isNumeric py={1} px={1}>
									<Menu>
										{({ isOpen }) => (
											<>
												<MenuButton
													border={0}
													fontSize="1.5626rem"
													as={IconButton}
													isActive={isOpen}
													aria-label="Options"
													icon={<FiMoreVertical />}
													variant="outline"
													_hover={{ bg: 'gray.50' }}
												/>

												<MenuList p={0} boxShadow='xl'>
													{/* DETALHES */}
													<MenuItem
														fontSize={16}
														fontWeight={500}
														py={3}
														_hover={{ bg: 'gray.50' }}
														onClick={() => {
															setTituloModal(titulo.fin_json);
															setModalTituloVisible(true);
														}}
													>
														Detalhes
													</MenuItem>

													{/* EDITAR */}
													{permissions.alterar && (
														<>
															<Divider />

															<MenuItem
																fontSize={16}
																fontWeight={500}
																py={3}
																_hover={{ bg: 'gray.50' }}
																onClick={() => {
																	setTituloModal(titulo.fin_json);
																	setModalTituloEditVisible(true);
																}}
															>
																Editar
															</MenuItem>
														</>
													)}

													{/* EXCLUIR */}
													{permissions.excluir && (
														<>
															<Divider />

															<MenuItem
																fontSize={16}
																fontWeight={500}
																py={3}
																_hover={{ bg: 'gray.50' }}
																isDisabled={
																	(titulo.fin_json.baixas && titulo.fin_json.baixas.length > 0) ||
																	(titulo.fin_json.documentos && titulo.fin_json.documentos.length > 0)
																}
																onClick={() => {
																	setTituloModal(titulo.fin_json);
																	setModalTituloDeleteVisible(true);
																}}
															>
																Excluir
															</MenuItem>
														</>
													)}
												</MenuList>
											</>
										)}
									</Menu>
								</Td>
							)}
            </Tr>
          );
        })}
      </Tbody>

			<Tfoot>
				<Tr>
					<Th></Th>
					<Th mx={0} px={0} pt={4}>Totais</Th>
					<Th></Th>
					<Th></Th>
					<Th isNumeric>{vCredTotal}</Th>
					<Th isNumeric>{vDebTotal}</Th>
					<Th isNumeric>{amortTotal}</Th>
					<Th isNumeric>{descontoTotal}</Th>
					<Th isNumeric>{jurosTotal}</Th>
					<Th isNumeric>{multaTotal}</Th>
					<Th isNumeric>{pagoTotal}</Th>
					<Th isNumeric>{sCredTotal}</Th>
					<Th isNumeric>{sDebTotal}</Th>
					<Th></Th>
					<Th></Th>
					<Th></Th>
					<Th></Th>
				</Tr>
			</Tfoot>
    </Table>
  );
};

export default DTTable;
